/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React, { useState, useEffect, useMemo } from "react";

import { bem } from "../../../shared/BEM";
import { DocumentManager } from "../../lib/DocumentManager";
import { NavLink } from "react-router-dom";
import { FormModel } from "../../../shared/FormModel/FormModel";

interface IDocumentMenuItemProps {
	item: FormModel;
	onClose?: (docId: string) => void;
}

function DocumentMenuItem(props: IDocumentMenuItemProps) {

	const [ state, setState ] = useState(props.item.getState());

	useEffect(() => {

		const handleUpdate = () => {
			setState(props.item.getState());
		};

		props.item.on("update", handleUpdate);
		props.item.getNameField().on("update", handleUpdate);

		return () => {
			props.item.off("update", handleUpdate);
			props.item.getNameField().off("update", handleUpdate);
		};

	}, [ props.item ]);

	const itemConfig = useMemo(() =>
		props.item.getConfig(),
	[ props.item ]);

	const handleClose = (ev) => {

		ev.stopPropagation();
		ev.preventDefault();

		props.onClose(state.id);

	};

	const stl = bem("menu-list");

	const itemMods = [];

	if (state.modified) {
		itemMods.push("modified");
	}

	return <li className={stl.el("item").mod(itemMods).str}>
		<NavLink to={`/doc/${state.id}`} className={stl.el("item-container").str}>
			<i className={`mdi mdi-${itemConfig.icon}`} />
			<span className={stl.el("item-contents").str}>
				<span className={stl.el("item-label").str}>{state.name || "Bez názvu"}</span>
				<span className={stl.el("item-description").str}>{itemConfig.title}</span>
			</span>
			{ props.onClose ?
				<button className={stl.el("item-close").str} onClick={handleClose}><i className="mdi mdi-close" /></button>
			: null }
		</NavLink>
	</li>;

}

/**
 * Component props
 */
export interface IOpenedDocumentsComponentProps {
	docMgr: DocumentManager;
}

/**
 * Opened documents menu
 *
 * @param props Component props
 */
export function OpenedDocuments(props: IOpenedDocumentsComponentProps) {

	const [ items, setItems ] = useState(() => props.docMgr.getList().slice());

	useEffect(() => {

		const updateHandler = () => {
			setItems(props.docMgr.getList().slice());
		};

		props.docMgr.on("update", updateHandler);

		return () => {
			props.docMgr.off("update", updateHandler);
		};

	}, []);

	const handleClose = useMemo(() => (docId: string) => {

		props.docMgr.close(docId);

	}, []);

	const stl = bem("menu-list");

	return <ul className={stl.str}>
		{items.map((item) => <DocumentMenuItem item={item} key={item.getId()} onClose={handleClose} />)}
	</ul>;

}
